/* assets/kua-copy.js — Extended Edition
 * Full content version for Kua Number Calculator.
 * Text expanded for more context and authenticity.
 */

window.KUA_COPY = {
  ui: {
    title: "The Only Accurate Kua Number Calculator",
    why_title: "WHY IS THIS THE ONLY ACCURATE KUA NUMBER CALCULATOR?",
    why_body:
      "The Eight Mansions (Ba Zhai) method follows the solar calendar, not the lunar one. Li Chun (Start of Spring) marks the true energetic beginning of each year and typically falls between Feb 3–5. Many online tools mistakenly use January 1, causing misalignment for those born around the transition period. Our calculator automatically adjusts by Li Chun, giving you the truest reflection of your personal energy pattern.",
    dob_label: "Date of Birth",
    gender_label: "Gender",
    select_placeholder: "Select…",
    gender_male: "Male",
    gender_female: "Female",
    gender_na: "Prefer not to say",
    cta_text: "Calculate Now",
    disclaimer:
      "We always determine your birth year by Li Chun.This ensures the highest fidelity to traditional Feng Shui standards.",
    result_prefix: "Your KUA NUMBER is",
    result_prefix_both: "Showing results for both genders",
    male_result: "Male result",
    female_result: "Female result"
  },

  labels: {
    element: "Element",
    color: "Color",
    group: "Group",
    trigram: "Trigram",
    four_good: "四大吉方 (Auspicious)",
    four_bad:  "四大凶方 (Inauspicious)",
    direction: "Direction",
    bad_generic: "Inauspicious",
    year: "Year",
    gender: "Gender",
    why_prefix: "Why",
    how_prefix: "What to do",
    good_title_map: {
      sheng_qi: "生气 (Sheng Qi) — Wealth/Vitality",
      tian_yi:  "天医 (Tian Yi) — Health/Benefactors",
      yan_nian: "延年 (Yan Nian) — Relationships/Team",
      fu_wei:   "伏位 (Fu Wei) — Stability/Study"
    },
    bad_title_map: {
      jue_ming: "绝命 (Jue Ming) — Calamity",
      wu_gui:   "五鬼 (Wu Gui) — Disputes/Petty people",
      liu_sha:  "六煞 (Liu Sha) — Lawsuits/Gossip",
      huo_hai:  "祸害 (Huo Hai) — Minor setbacks"
    }
  },

  dir_full: {
    N:"North (N)", E:"East (E)", S:"South (S)", W:"West (W)",
    NE:"Northeast (NE)", NW:"Northwest (NW)", SE:"Southeast (SE)", SW:"Southwest (SW)"
  },

  meta: {
    "1": { element: "Water", colors: "Black, Blue", group:"East", trigram:"Kan"  },
    "2": { element: "Big Earth", colors: "Yellow, Beige, Taupe", group:"West", trigram:"Kun"  },
    "3": { element: "Wood", colors: "Green", group:"East", trigram:"Zhen" },
    "4": { element: "Wood", colors: "Green, Teal", group:"East", trigram:"Xun"  },
    "5": { element: "Earth (Central)", colors: "Yellow, Beige",
           group:"Special", trigram:"Center",
           note:"Kua 5 converts: Male → 2 (Kun), Female → 8 (Gen). Usually not shown as a standalone result." },
    "6": { element: "Metal", colors: "White, Silver, Gold", group:"West", trigram:"Qian" },
    "7": { element: "Metal", colors: "White, Rose Gold", group:"West", trigram:"Dui" },
    "8": { element: "Young Earth", colors: "Yellow, Beige", group:"West", trigram:"Gen" },
    "9": { element: "Fire", colors: "Red, Purple, Orange", group:"East", trigram:"Li" }
  },

  explain: {
    good: {
      sheng_qi:
        "The strongest source of life energy (Qi). Activating this direction promotes wealth, success, and opportunities. Ideal for business growth and career advancement.",
      tian_yi:
        "Symbolizes Heaven’s healing and assistance. This direction brings mentors, benefactors, and robust health. A perfect place for recovery or rejuvenation.",
      yan_nian:
        "Represents long relationships and harmony. It enhances family ties, teamwork, and reputation, fostering loyalty and social balance.",
      fu_wei:
        "The foundation of inner peace and personal strength. Encourages focus, discipline, and spiritual clarity. Best for study or meditation."
    },
    bad: {
      jue_ming:
        "The most destructive energy. It may bring illness, loss, or sudden misfortune if used wrongly. Avoid orienting key spaces toward it.",
      wu_gui:
        "The Five Ghosts energy triggers disputes, gossip, and accidents. It can disturb concentration and emotional calmness.",
      liu_sha:
        "Linked with lawsuits and moral entanglements. Keeping away from this direction prevents unnecessary stress and friction.",
      huo_hai:
        "The least harmful of the inauspicious directions, but still drains focus and luck subtly over time.",
      generic:
        "Generally unfavorable for sustained work or rest. Avoid using it for entrances, beds, or main desks."
    }
  },

  good_map: {
    "1": { sheng_qi:"SE", tian_yi:"E",  yan_nian:"S",  fu_wei:"N"  },
    "3": { sheng_qi:"S",  tian_yi:"SE", yan_nian:"N",  fu_wei:"E"  },
    "4": { sheng_qi:"N",  tian_yi:"E",  yan_nian:"S",  fu_wei:"SE" },
    "9": { sheng_qi:"E",  tian_yi:"SE", yan_nian:"N",  fu_wei:"S"  },
    "2": { sheng_qi:"NE", tian_yi:"W",  yan_nian:"NW", fu_wei:"SW" },
    "6": { sheng_qi:"SW", tian_yi:"W",  yan_nian:"NE", fu_wei:"NW" },
    "7": { sheng_qi:"NE", tian_yi:"NW", yan_nian:"SW", fu_wei:"W"  },
    "8": { sheng_qi:"W",  tian_yi:"SW", yan_nian:"NW", fu_wei:"NE" }
  },

  bad_order: ["jue_ming","wu_gui","liu_sha","huo_hai"],
  bad_map: {
    "1": { "NW":"jue_ming","NE":"wu_gui","SW":"liu_sha","W":"huo_hai" },
    "3": { "SW":"jue_ming","NW":"wu_gui","NE":"liu_sha","W":"huo_hai" },
    "4": { "W":"jue_ming","SW":"wu_gui","NW":"liu_sha","NE":"huo_hai" },
    "9": { "W":"jue_ming","NE":"wu_gui","SW":"liu_sha","NW":"huo_hai" },
    "2": { "E":"jue_ming","S":"wu_gui","N":"liu_sha","SE":"huo_hai" },
    "6": { "S":"jue_ming","E":"wu_gui","N":"liu_sha","SE":"huo_hai" },
    "7": { "SE":"jue_ming","S":"wu_gui","E":"liu_sha","N":"huo_hai" },
    "8": { "S":"jue_ming","SE":"wu_gui","E":"liu_sha","N":"huo_hai" }
  },

  // ---------- Expanded advice cards ----------
  advice: {
    wealth: {
      title: "Your wealth direction",
      why: "This direction embodies the flow of Sheng Qi—the energy of creation, opportunity, and prosperity. When you align yourself with this axis, your environment becomes magnetically attuned to abundance. In classical Feng Shui, this orientation connects your personal element with the universe’s generative cycle, helping projects succeed and financial doors open. By facing your wealth direction, you are symbolically and energetically facing the future you desire to build.",
      how: "Place your work desk or primary seat so that you face this direction when making financial decisions, studying, or brainstorming. You can also enhance the area by introducing symbols of wealth such as flowing water, fresh plants, or metal accents. Keep the space clean, bright, and uncluttered—this ensures Qi circulates freely. Avoid stagnant corners or broken décor here, as they can trap fortune energy."
    },
    health: {
      title: "Your health direction",
      why: "This direction channels Tian Yi, the ‘Heavenly Doctor’ energy. It’s said to strengthen immunity, invite helpful people, and guard against long-term imbalance. By activating this zone, you harmonize body and environment, reinforcing resilience and emotional calm. In modern terms, it’s where your biological and spatial rhythms align, fostering sustainable vitality.",
      how: "Sleep with your head pointing toward this direction or rest facing it during meditation. Add gentle elements—green plants, soft light, or objects representing nature’s renewal. Avoid electronics or clutter nearby. If you’re recovering or seeking guidance, this direction supports encounters with healers and mentors who accelerate your growth."
    },
    love: {
      title: "Your relationship direction",
      why: "This corresponds to Yan Nian, symbolizing long relationships and collective harmony. It enhances bonds of trust, communication, and empathy—whether between partners, friends, or colleagues. Activating it helps smooth emotional friction and opens space for cooperation and understanding. It also strengthens your personal charm and aura of warmth.",
      how: "Orient shared spaces—bedroom, dining area, or living room—toward this direction. Place paired objects such as candles, artworks, or decorative stones to represent partnership. Keep the area filled with soft colors and balanced lighting to promote warmth. When discussing important matters with loved ones, sit or face toward this orientation to encourage open dialogue."
    },
    growth: {
      title: "Your growth direction",
      why: "Associated with Fu Wei, this direction fosters self-discipline, focus, and inner balance. It stabilizes your thoughts and anchors the willpower needed for long-term goals. In metaphysical theory, Fu Wei harmonizes your inner Qi, letting wisdom emerge naturally rather than through struggle. It’s ideal for personal reflection and creative breakthroughs.",
      how: "Use this direction for study, reading, journaling, or decision-making. Design the area with calm tones—wood, earth, or soft light—and avoid clutter or excessive technology. Incorporate natural textures or sacred symbols that remind you of your purpose. When seeking clarity in life choices, meditate facing this way to center your energy."
    },
    cautious: {
      title: "Direction to be cautious about",
      why: "This direction carries one of your inauspicious influences. Prolonged exposure here can create subtle resistance: plans stall, focus scatters, or relationships feel strained. It’s not that the space is cursed—it simply vibrates out of tune with your elemental pattern. Awareness and avoidance are the best remedies.",
      how: "Avoid using this direction for your main door, bed head, or office desk. If relocation isn’t possible, soften its impact by adding natural light, grounding materials (like earth tones or plants), and minimizing sharp edges. Keep movement and sound gentle—Qi should flow smoothly, not rush. In general, reserve this zone for storage or low-importance activities."
    }
  }
};
